import type { XrayListFilterName } from 'services/analytics'
import { DiagnosticFilters } from '../types'

const sameItems = (a: readonly string[], b: readonly string[]) =>
  a.length === b.length && a.every(item => b.includes(item))

/** Nomes dos filtros que diferem do padrão — nunca os valores (vão para o analytics). */
export const changedFilterNames = (
  filters: DiagnosticFilters,
  defaults: DiagnosticFilters
): XrayListFilterName[] => {
  const changed: XrayListFilterName[] = []
  if (!sameItems(filters.subtypes, defaults.subtypes)) changed.push('subtypes')
  if (!sameItems(filters.diagnosticTypes, defaults.diagnosticTypes))
    changed.push('diagnosticTypes')
  if (filters.examDateStart || filters.examDateEnd) changed.push('examDate')
  if (filters.patientId.trim()) changed.push('patientId')
  if (filters.examId.trim()) changed.push('examId')
  if (filters.diagnosticId.trim()) changed.push('diagnosticId')
  if (filters.status !== defaults.status) changed.push('status')
  if (!sameItems(filters.review, defaults.review)) changed.push('review')
  if (!sameItems(filters.priority, defaults.priority)) changed.push('priority')
  return changed
}
